import { Component } from '@angular/core';

@Component({
  selector: 'ez-required-fields-hint',
  templateUrl: './required-fields-hint.component.html',
  styleUrl: './required-fields-hint.component.scss',
})
export class RequiredFieldsHintComponent {}
